import React from 'react';
import classnames from 'classnames';

import Button from './Button';

const PricingPlanCard = ({
  annualBilledActive,
  bullets,
  ctaLink,
  ctaText,
  description,
  id,
  name,
  plans,
  theme,
}) => {
  const buttonColour = theme === 'DARK' ? 'white' : 'grey';
  const buttonHoverColour = theme === 'DARK' ? 'white' : theme.toLowerCase();
  const buttonHref = ctaLink || 'https://app.graphcms.com/signup';
  const hasMultiplePlans = plans.length >= 2;

  return (
    <div
      key={id}
      className={classnames(
        'flex flex-col overflow-hidden border-t-8 rounded shadow-image',
        {
          'bg-white border-cornflower text-light-haiti': theme === 'PURPLE',
          'bg-white border-rose text-light-haiti': theme === 'PINK',
          'bg-haiti border-zodiac text-white': theme === 'DARK',
        }
      )}
    >
      <div className="lg:h-84 px-6 py-8">
        <div className="mb-5">
          <p className="font-medium tracking-wide uppercase">{name}</p>
        </div>
        <div>
          {hasMultiplePlans ? (
            <div className="bg-whisper px-6 py-5 rounded text-center">
              <div className="divide-x grid grid-cols-2 mb-4">
                {plans.map((plan) => (
                  <div key={plan.id} className="py-1 lg:py-0">
                    <h4 className="font-medium text-sm">{plan.headline}</h4>
                    <p className="font-bold text-haiti text-3xl">
                      {annualBilledActive
                        ? plan.formattedAnnualPrice
                        : plan.formattedMonthlyPrice}
                    </p>
                  </div>
                ))}
              </div>
              <p className="text-xs">
                {annualBilledActive
                  ? 'per project per month (billed yearly)'
                  : 'per project per month (billed monthly)'}
              </p>
            </div>
          ) : (
            plans.map((plan) => (
              <div key={plan.id}>
                <h3
                  className={classnames(
                    'font-bold leading-10 mb-5 text-4xl',

                    {
                      'text-haiti': ['PURPLE', 'PINK'].includes(theme),
                      'text-white': theme === 'DARK',
                    }
                  )}
                >
                  {plan.headline}
                </h3>
              </div>
            ))
          )}
          <p className="mt-5">{description}</p>
        </div>
      </div>
      <div
        className={classnames('flex flex-1 flex-col px-6 py-5', {
          'bg-whisper': ['PURPLE', 'PINK'].includes(theme),
          'bg-zodiac': theme === 'DARK',
        })}
      >
        <ul className="flex-1 list-outside list-disc mb-10 px-3 space-y-3">
          {bullets.map((bullet, index) => (
            <li
              key={index}
              className={classnames('text-sm', {
                'text-cornflower': theme === 'PURPLE',
                'text-rose': theme === 'PINK',
              })}
            >
              <span
                className={classnames({
                  'text-light-haiti': ['PURPLE', 'PINK'].includes(theme),
                })}
              >
                {bullet}
              </span>
            </li>
          ))}
        </ul>
        <Button
          colour={buttonColour}
          href={buttonHref}
          hover={buttonHoverColour}
          block
        >
          {ctaText}
        </Button>
      </div>
    </div>
  );
};

export default PricingPlanCard;
